import createIcon from '../../createIcon';

/**
 * @component @name Done
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOC44MDAyIDE1LjlMNC42MDAyIDExLjdMMy4yMDAyIDEzLjFMOC44MDAyIDE4LjdMMjAuODAwMiA2LjcwMDA1TDE5LjQwMDIgNS4zMDAwNUw4LjgwMDIgMTUuOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Done = createIcon('Done', [
  [
    'path',
    {
      d: 'M8.8002 15.9L4.6002 11.7L3.2002 13.1L8.8002 18.7L20.8002 6.70005L19.4002 5.30005L8.8002 15.9Z',
      key: '2iqw1l',
    },
  ],
]);

export default Done;
